<script setup lang="ts">
import {default as templateStore} from "@/store";
import ScoutsLogo from "@/components/Common/ScoutsLogo.vue";
import LoadingSpin from "@/components/Common/LoadingSpin.vue";
import ContentHolder from "@/components/RegistrationPage/PcVersion/ContentHolder.vue";
import ToolTip from "@/components/RegistrationPage/PcVersion/ToolTip.vue";
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'RegistrationPagePcVersion',
})
</script>

<template>
    <div class="main">
        <div class="wrapper">
            <ScoutsLogo/>

            <Transition name="fade" mode="out-in">
                <LoadingSpin v-if="templateStore.state.passes.length === 0"/>
                <ContentHolder v-else/>
            </Transition>
        </div>

        <ToolTip/>
    </div>
</template>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.main {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    padding: 30px 0 0 0;
    overflow: hidden;
    overflow-y: scroll;

    display: flex;
    justify-content: center;
}

.wrapper {
    position: relative;
    z-index: 900;
    width: fit-content;

    display: flex;
    flex-direction: column;
    gap: 50px;
    justify-content: flex-start;
    align-items: center;
}

.paddingWorkaround {
    font-size: 1px;
    color: transparent;
    margin-top: 50px;
}
</style>
